<template>
  <MasterHeader />
  <div class="u-containar responsive">
    <div>
      <HeadingLv3 text="バックナンバー一覧" />
      <ExamMasterList />
      <Pagination class="pagination" :totalPages="state.totalPages" />
      <Button
        label="国試マスタートップへ戻る"
        primary
        border
        :handleClick="
          () => {
            $router.push('/magazines/exam/master/')
          }
        "
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ExamMasterList from '@/components/block/ExamMasterList.vue'
import MasterHeader from '@/components/block/MasterHeader.vue'
import Pagination from '@/components/block/Pagination.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import { useTest } from '@/provider/test'

export default defineComponent({
  name: 'examMasterList',

  components: {
    ExamMasterList,
    MasterHeader,
    Pagination,
    HeadingLv3,
    Button
  },

  setup() {
    const { state } = useTest()
    return {
      state
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.responsive {
  margin-top: 50px;
  @include mixins.media() {
    display: grid;
    grid-template-columns: 1fr 336px;
    gap: 30px;
  }
}
.pagination {
  margin: 40px auto;
  width: 100%;
  max-width: 400px;
}
::v-deep .backnumberTab > li {
  @include mixins.media() {
    max-width: 100px;
  }
}
::v-deep .backnumberTab-container {
  @include mixins.media() {
    margin: 16px 0;
  }
}
</style>
